import { Badge } from "@/components/ui/badge";
import { poolPurposeLabel } from "@/lib/pool-purpose";
import type { PoolPurpose } from "@/lib/types";
import { cn } from "@/lib/utils";

export function PoolPurposeBadge({ purpose }: { purpose: PoolPurpose }) {
  return (
    <Badge
      variant="outline"
      title={`Intended use: ${poolPurposeLabel(purpose)}`}
      className={cn(
        "whitespace-nowrap text-[10px] font-medium",
        purpose === "rd" && "border-sky-500/20 bg-sky-500/10 text-sky-700 dark:text-sky-300",
        purpose === "ci" &&
          "border-violet-500/20 bg-violet-500/10 text-violet-700 dark:text-violet-300",
      )}
    >
      {poolPurposeLabel(purpose)}
    </Badge>
  );
}
